export default __webpack_public_path__ + "static/media/conversation-sync-2.89add275.svg";